import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    description: 'importCustomersModal.title',
    defaultMessage: 'Import Customers',
    id: 'Uvcghn',
  },
  startImport: {
    description: 'importCustomersModal.startImport',
    defaultMessage: 'Start Import',
    id: 'I4jKv6',
  },
  cancel: {
    description: 'importCustomersModal.cancel',
    defaultMessage: 'Cancel',
    id: 'HtxNfN',
  },
  close: {
    description: 'importCustomersModal.close',
    defaultMessage: 'Close',
    id: 'oAwF3b',
  },
  importCustomersSummary: {
    description: 'importCustomersModal.importCustomersSummary',
    defaultMessage:
      "If you'd like to import customer information (e.g. an existing address book), you can provide your data in our standard CSV file format. Customer records are unique to each marketplace supported by ShipStation.",
    id: 'naqkZh',
  },
  downloadSampleCsv: {
    description: 'importCustomersModal.downloadSampleCsv',
    defaultMessage: 'Download a sample CSV file',
    id: '6uF3IH',
  },
  selectFile: {
    description: 'importCustomersModal.selectFile',
    defaultMessage: '1. Select a File to Import',
    id: 'Ryai5t',
  },
  selectAFile: {
    description: 'importCustomersModal.selectAFile',
    defaultMessage: 'Select a File',
    id: '+GX3ZI',
  },
  selectOptions: {
    description: 'importCustomersModal.selectOptions',
    defaultMessage: '2. Select Options',
    id: '4wuvQz',
  },
  selectOptionsSummary: {
    description: 'importCustomersModal.selectOptionsSummary',
    defaultMessage:
      'ShipStation will match the new data against your existing records based on username. If the username is already on file...',
    id: 'XRuBI+',
  },
  updateSelectOption: {
    description: 'importCustomersModal.updateSelectOption',
    defaultMessage: 'Update the existing record with the csv.',
    id: '27P5+Q',
  },
  ignoreSelectOption: {
    description: 'importCustomersModal.ignoreSelectOption',
    defaultMessage: 'Ignore the record in the csv. Only customers with new usernames will import.',
    id: '+stMxR',
  },
  importCustomersUploadMessage: {
    description: 'importCustomersModal.importCustomersUploadMessage',
    defaultMessage:
      'Your upload has been sent! This may take a while so feel free to close this window. We will notify you when the import process is complete.',
    id: 'KRXVms',
  },
  notCsvError: {
    description: 'customer import modal error when file is not .csv',
    defaultMessage: 'Please select a .CSV file',
    id: 'EqB6O1',
  },
});

export default messages;
